import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { type ResourceForm, useResourcesStore } from '@/stores/resources-store';

export type FormOption = ResourceForm;

export function useForms() {
  const { forms, loading, errorMessage, loadForms } = useResourcesStore(
    useShallow((state) => ({
      forms: state.forms,
      loading: state.isLoadingForms,
      loadForms: state.loadForms,
      errorMessage: state.formsError,
    })),
  );

  useEffect(() => {
    void loadForms();
  }, [loadForms]);

  return { forms, loading, error: errorMessage ? new Error(errorMessage) : null };
}
